import { lazyRoute, preloadLazyRoute } from "utils/lazyRoute";

const shareImport = () => import("layouts/Share");

export const LazyShare = lazyRoute(shareImport);
LazyShare.displayName = "Share";

export const preloadShare = () => preloadLazyRoute(shareImport);
